import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React, { forwardRef, Ref, useEffect } from 'react'

import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import { SelectedFilter } from '../../domains/CollectionFilter'

import styles from './noProducts.module.scss'

interface NoProductProps {
  className?: string
  onResetFilters: (selectedFilters: SelectedFilter) => void
  isNewCLPFiltersExperimentActive?: boolean
}

const NoProduct = forwardRef((props: NoProductProps, ref: Ref<HTMLDivElement>) => {
  const { t } = useTranslation()
  const classes = classnames(styles.wrapper, props.className, {
    [`${styles.newCLPFilters}`]: props.isNewCLPFiltersExperimentActive,
  })

  useEffect(() => {
    trackEvent(TELEMETRY_EVENT_NAMES.EMPTY_FILTERED_RESULTS, {})
  }, [])

  const handleResetFilters = () => {
    props.onResetFilters(new SelectedFilter({}))
  }

  return (
    <div className={classes} ref={ref}>
      <div className={styles.header}>{t('no_product_found')}</div>
      <button className={styles.reset} onClick={handleResetFilters}>
        {t('reset_filter')}
      </button>
    </div>
  )
})

NoProduct.displayName = 'NoProduct'

export default NoProduct
